import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams  } from "@angular/common/http";
import { environment } from "../../environments/environment";

import { Observable } from "rxjs";
import { param } from "jquery";

@Injectable({
  providedIn: "root"
})
export class ApiService {
  private headers: any;
  constructor(private _http: HttpClient) {
    this.headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json"
      })
    };
  }

  GetRequest(Path): Observable<any> {
    return this._http.get(`${environment.baseUrl}/${Path}`, this.headers);
  }

  PostRequest(Path, data): Observable<any> {
    return this._http.post(
      `${environment.baseUrl}/${Path}`,
      JSON.stringify(data),
      this.headers
    );
  }

  DeleteRequest(Path): Observable<any> {
    return this._http.delete(`${environment.baseUrl}/${Path}`, this.headers);
  }

  auth(data): Observable<any> {
    // return this.PostRequest('auth', data);
    //return this._http.post('https://api.sma.infi.cf/auth', JSON.stringify(data), this.headers);
    return this._http.post(
      `${environment.apiUrl}/auth`,
      JSON.stringify(data),
      this.headers
    );
  }

  socialSignIn(data): Observable<any> {
    //return this._http.post('https://api.sma.infi.cf/social-sign-on', JSON.stringify(data), this.headers);
    return this._http.post(
      `${environment.apiUrl}/social-sign-on`,
      JSON.stringify(data),
      this.headers
    );
  }

  refreshToken(): Observable<any> {
    //return this._http.post('https://api.sma.infi.cf/auth/refresh', {});
    return this._http.post(`${environment.apiUrl}/auth/refresh`, {});
  }

  registerUser(data): Observable<any> {
    return this.PostRequest("auth/register", data);
  }
  /*********************/
  //Partner API : [START]
  /*********************/
  partnerAuth(data): Observable<any> {
    return this._http.post(
      `${environment.apiUrl}/frontend/partner/login`,
      JSON.stringify(data),
      this.headers
    );
  }

  registerPartner(data): Observable<any> {
    return this.PostRequest("partner/signup", data);
  }

  getPartnerDashboard(data): Observable<any> {
    return this.PostRequest("partner/dashboard", data);
  }

  addPartnerClient(data): Observable<any> {
    return this.PostRequest("partner/client/link", data);
  }

  /*********************/
  //Partner API : [END]
  /*********************/

  subscribePlans(): Observable<any> {
    return this.GetRequest("subscribe");
  }

  getcountryCodes(): Observable<any> {
    return this.GetRequest("list/country");
  }

  sendOTP(data): Observable<any> {
    return this.PostRequest("sendOtp", data);
  }

  verifyOTP(data): Observable<any> {
    return this.PostRequest("verifyOtp", data);
  }

  forgotPassword(data): Observable<any> {
    return this.PostRequest("forgot-password", data);
  }

  resetPassword(token, data): Observable<any> {
    return this.PostRequest("reset-password/" + token, data);
  }

  verifyUserToken(data): Observable<any> {
    //return this._http.get(`https://api.sma.infi.cf/verify/${data}`, this.headers);
    return this._http.get(`${environment.apiUrl}/verify/${data}`, this.headers);
  }

  getUserPortfolios(data): Observable<any> {
    return this.PostRequest("getUserPortfolio", data);
  }

  //Get User Details
  getUserDetails(data): Observable<any> {
    return this.PostRequest("client-details/get", data);
  }

  //Create/Update User Details
  createUpdateUserDetails(data): Observable<any> {
    return this.PostRequest("client-details/update", data);
  }

  getUserWatchList(data): Observable<any> {
    return this.PostRequest("watchList", data);
  }

  deleteUserPortfolio(data): Observable<any> {
    return this.PostRequest("DeleteStockUserDetails", data);
  }

  deleteWatchlist(data): Observable<any> {
    return this.PostRequest("delete/watchList", data);
  }

  updateUserStocks(data): Observable<any> {
    return this.PostRequest("updateStockUserReport", data);
  }

  getUserCummulativeportfolios(data): Observable<any> {
    return this.PostRequest("getStockUserDetails", data);
  }

  addPortfolio(data): Observable<any> {
    return this.PostRequest("insertStockUserDetails", data);
  }
  updatePortfolio(data): Observable<any> {
    return this.PostRequest("updateStockUserDetails", data);
  }

  updateUserProfile(data): Observable<any> {
    return this.PostRequest("update-profile", data);
  }

  getPortfolioIndexDetails(data): Observable<any> {
    return this.PostRequest("portfolioOutput", data);
  }

  getPortfolioIndexNews(data): Observable<any> {
    return this.PostRequest("list/companyNews", data);
  }

  getTopShareholdingCompanies(data): Observable<any> {
    return this.PostRequest("getShareholdingMorethanOnePercent", data);
  }

  getPortfolioIndex(data): Observable<any> {
    return this.PostRequest("getPortfolio", data);
  }

  getMFPortfolios(): Observable<any> {
    return this.GetRequest("mutual-funds/portfolios");
  }

  getMfPortfolioDetails(data): Observable<any> {
    return this.GetRequest(`mutual-funds/portfolios/${data}`);
  }

  getCompanyPortfolio(data): Observable<any> {
    return this.PostRequest("getCompanyPortFolio", data);
  }

  getThemes(): Observable<any> {
    return this.GetRequest("get/theme");
  }

  getMFThemes(): Observable<any> {
    return this.GetRequest("mutual-funds/theme");
  }

  getThemeDetails(data): Observable<any> {
    return this.GetRequest(`get/theme/companyList/${data}`);
  }

  getMFThemeDetails(data): Observable<any> {
    return this.GetRequest(`mutual-funds/theme/schemeList/${data}`);
  }

  getBlog(data): Observable<any> {
    return this.PostRequest(`get/blog`, data);
  }

  getBlogDetails(data): Observable<any> {
    return this.GetRequest(`get/blog/companyList/${data}`);
  }

  becomeAPartner(data): Observable<any> {
    return this.PostRequest(`becomePartner`, data);
  }

  submitFeedback(data): Observable<any> {
    return this.PostRequest(`feedback`, data);
  }

  subscribeNewsletter(data): Observable<any> {
    return this.PostRequest(`insert/Newsletter`, data);
  }

  getSchemePortfolio(data): Observable<any> {
    //return this._http.get(`https:///api.sma.infi.cf/mutual-funds/summary/${data}`);
    return this._http.get(`${environment.apiUrl}/mutual-funds/summary/${data}`);
  }

  getSearchResults(data): Observable<any> {
    return this.GetRequest(`search?q=${data}`);
  }

  addStockToWatchlist(data): Observable<any> {
    return this.PostRequest(`watchList/add`, data);
  }

  addSchemeToWatchlist(data): Observable<any> {
    return this.PostRequest(`mutual-funds/watchlist`, data);
  }

  getSchemeWatchlist(): Observable<any> {
    return this.GetRequest(`mutual-funds/watchlist`);
  }
  deleteSchemeWatchlist(data): Observable<any> {
    return this._http.post(
      `${environment.baseUrl}/mutual-funds/watchlist/delete`,
      JSON.stringify(data),
      this.headers
    );
  }

  getUserTransactions(): Observable<any> {
    return this.GetRequest(`mutual-funds/form?name=user_transactions`);
  }

  getUserTransaction(id): Observable<any> {
    return this.GetRequest(
      `mutual-funds/form?name=user_transactions&transaction_id=${id}`
    );
  }

  addUserTransaction(data): Observable<any> {
    return this._http.post(
      `${environment.baseUrl}/mutual-funds/form?name=user_transactions`,
      JSON.stringify(data),
      this.headers
    );
  }

  updateTransaction(data): Observable<any> {
    return this._http.put(
      `${environment.baseUrl}/mutual-funds/form?name=user_transactions`,
      JSON.stringify(data),
      this.headers
    );
  }

  deleteUserTransaction(data): Observable<any> {
    this.headers.body = JSON.stringify(data);
    return this._http.delete(
      `${environment.baseUrl}/mutual-funds/form?name=user_transactions`,
      this.headers
    );
  }

  getUserSchemePortfolio(): Observable<any> {
    return this.GetRequest(`mutual-funds/user/portfolio`);
  }

  //--MF-Recommended----
  getMfRecommended(url: string): Observable<any> {
    return this.GetRequest(`/${url}`);
  }

  downloadPdfFile(data): Observable<any> {
    return this._http.post(
      `${environment.baseUrl}/pms/document-download`,
      JSON.stringify(data),
      this.headers
    );
  }

  getStockTTM(data): Observable<any> {
    /* let headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json"
      }),
      //params: new HttpParams().set('co_code', '21272')
      body: data
    };
    return this._http.get(`${environment.baseUrl}/stock-ttm`, headers); */
    return this.PostRequest(`stock-ttm`, data);
    /* this.headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json"
      })
    };
    return this._http.post(
      `${environment.baseUrl}/stock-ttm`,
      JSON.stringify(data),
      this.headers
    ); */
  }

}
